/** Node の req.headers と Fetch Headers の両方で小文字化後にこの接頭辞で始まるものを Ecbo FF とみなす */
export const ECBO_HEADER_PREFIX = 'x-ecbo-'

/** Cookie にミラーしたフラグ JSON を載せる名前（クライアントから読むため HttpOnly: false） */
export const ECBO_FF_COOKIE_NAME = 'ecbo_feature_flags'

/** 1 値あたりの上限（Chrome 拡張側の sanitize と揃える） */
export const ECBO_MAX_VALUE_LENGTH = 8192

/** ヘッダ本数の上限（Cookie 肥大化・DoS 防止） */
export const ECBO_MAX_FLAG_KEYS = 32

/** Cookie 値（JSON 文字列）の上限バイト相当（ブラウザの 4KB 制限に余裕を持たせる） */
export const ECBO_MAX_COOKIE_JSON_LENGTH = 3500
